import React, { createContext, useContext, useState } from 'react';

export interface CollapsibleContextProps {
  addCollapsible: (collapsible: Collapsible) => void;
  getCollapsibles: () => Collapsible[];
  removeCollapsible: (collapsible: Collapsible) => void;
  updateCollapsible: (collapsible: Collapsible) => void;
}

export interface Collapsible {
  collapsed: boolean;
  identifier: string;
}

export const CollapsibleContext = createContext<CollapsibleContextProps>(null);

export const useCollapsibleContext = (): CollapsibleContextProps => useContext(CollapsibleContext);

export const CollapsibleContextProvider = ({ children, ...props }): JSX.Element => {
  const [collapsibles, setCollapsibles] = useState<Collapsible[]>([]);

  return (
    <CollapsibleContext.Provider
      value={{
        addCollapsible: (collapsible) => {
          let newCollapsibles: Collapsible[] = [];
          newCollapsibles = newCollapsibles.concat(collapsibles);
          newCollapsibles.push(collapsible);
          setCollapsibles(newCollapsibles);
        },
        getCollapsibles: () => collapsibles,
        removeCollapsible: (collapsible) => {
          let newCollapsibles: Collapsible[] = [];
          newCollapsibles = newCollapsibles.concat(collapsibles);
          newCollapsibles = newCollapsibles.filter(
            (cllpsbl) => cllpsbl.identifier !== collapsible.identifier,
          );
          setCollapsibles(newCollapsibles);
        },
        updateCollapsible: (collapsible) => {
          const toUpdate: Collapsible = collapsibles.filter(
            (cllpsbl) => cllpsbl.identifier === collapsible.identifier,
          )[0];
          toUpdate.collapsed = collapsible.collapsed;
          let newCollapsibles: Collapsible[] = [];
          newCollapsibles = newCollapsibles.concat(collapsibles);
          newCollapsibles = newCollapsibles.filter(
            (cllpsbl) => cllpsbl.identifier !== collapsible.identifier,
          );
          newCollapsibles.push(toUpdate);
          setCollapsibles(newCollapsibles);
        },
      }}
      // props need to be passed in this way
      // eslint-disable-next-line
      {...props}
    >
      {children}
    </CollapsibleContext.Provider>
  );
};

export default CollapsibleContextProvider;
